import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsappRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 4,
		y: 4,
		width: 24,
		height: 24,
		rx: 6,
		fill: "#31c551"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.33 10.352a8.03 8.03 0 0 0-12.616 9.725l-.02-.038-1.14 4.161 4.257-1.117a7.9 7.9 0 0 0 3.837.978h.003a8.032 8.032 0 0 0 5.68-13.708m-5.68 12.352h-.002a6.63 6.63 0 0 1-3.426-.947l.03.017-.244-.144-2.525.663.673-2.463-.158-.253a6.6 6.6 0 0 1-1.02-3.546 6.674 6.674 0 1 1 6.673 6.673m3.661-4.997c-.2-.1-1.186-.585-1.37-.653-.184-.067-.318-.1-.452.101-.133.2-.518.652-.635.786-.117.135-.235.15-.435.05a5.5 5.5 0 0 1-1.619-1l.005.005a6 6 0 0 1-1.1-1.362l-.015-.028c-.117-.2-.012-.309.087-.409.09-.09.201-.234.301-.35q.12-.148.198-.327l.003-.01a.36.36 0 0 0-.018-.352l.002.002c-.051-.1-.452-1.088-.619-1.49-.163-.392-.329-.338-.452-.344a9 9 0 0 0-.384-.007.73.73 0 0 0-.534.25v.001a2.24 2.24 0 0 0-.702 1.676v-.002c.07.792.368 1.504.825 2.083l-.007-.008a9 9 0 0 0 3.377 3.006l.05.023c.297.134.676.277 1.064.4l.08.022a2.76 2.76 0 0 0 1.28.077l-.017.003a2.07 2.07 0 0 0 1.349-.945l.005-.01a1.64 1.64 0 0 0 .115-.963l.002.01c-.05-.084-.184-.133-.385-.234z",
		fill: "#fff"
	})]
});
export default SvgWhatsappRegularIcon;
